import { Inject, Injectable } from '@angular/core';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RecordsService {

constructor(private dataSrv: DataService) { }

assignRecordsToCampaign(campaignId: number){
    const url = environment.api + "campaign/assign_records_campaign.php";
    return this.dataSrv.post(url, {campaignId: campaignId});
}

resetAllRecords(campaigns: number[]){
    const url = environment.api + "campaign/reset_all_campaigns_records.php";
    return this.dataSrv.post(url, {campaignsIds: campaigns});
}

getCampaignRandomRecord(campaignId: number, caller_id: number){
    const url = environment.api + "campaign/get_single_random_record_by_campaign.php";
    return this.dataSrv.post(url, { campaign: campaignId, caller_id: caller_id });
}

}
